// Mirrors of the tristar-corp-api models the site uses. Dates arrive as ISO strings.

export enum AccountState {
    Disabled = 0,
    Enabled = 1
}

// Claim values are the API's (Src/Models/ClaimTypes.ts), including its legacy domain.
export const SiteAdministratorClaim = 'https://roguealphawaves.com/claims/SiteAdministrator';
export const UserClaim = 'https://roguealphawaves.com/claims/User';

export interface TokenSet {
    accessToken: string;
    refreshToken: string;
    avatarUrl: string;
}

export interface UserViewModel {
    username: string;
    emailAddress: string;
    displayName: string;
    status: AccountState;
    claims: string[];
    avatarUrl: string;
    timezone: string;
    language: string;
    defaultProjectId?: string;
    createdOn: string;
    createdBy: string;
    modifiedOn: string;
    modifiedBy: string;
}

export interface NewUserBindingModel {
    username: string;
    emailAddress: string;
    displayName: string;
    claims: string[];
    avatarUrl: string;
    timezone: string;
    language: string;
}

// The API replaces every one of these fields, so send the current values of those not being changed.
export interface UpdateUserBindingModel {
    displayName: string;
    avatarUrl: string;
    timezone: string;
    language: string;
    defaultProjectId?: string;
    status: AccountState;
    claims: string[];
}

export interface ProfileBindingModel {
    displayName: string;
    avatarUrl: string;
    timezone: string;
    language: string;
    defaultProjectId?: string;
}

export interface LicenseActivationViewModel {
    id: string;
    machineName: string;
    os: string;
    productVersion: string;
    activatedOn: string;
    lastSeen: string;
}

export interface LicenseViewModel {
    id: string;
    key: string;
    licensee: string;
    edition: string;
    ownerUsername: string;
    revoked: boolean;
    seats: number;
    activationsPerYear: number;
    activationsThisYear: number;
    activations: LicenseActivationViewModel[];
    createdOn: string;
}

export interface LicenseBindingModel {
    licensee: string;
    edition: string;
    ownerUsername: string;
    revoked: boolean;
}

export interface NewLicenseBindingModel extends LicenseBindingModel {
    key?: string;
}

export const Editions = ['Standard', 'Educational'];
